import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module upload/ui/filedialogbuttonview
 */
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import View from '@ckeditor/ckeditor5-ui/src/view';
/**
 * The file dialog button view.
 *
 * This component provides a button that opens the native file selection dialog.
 * It can be used to implement the UI of a file upload feature.
 *
 *		const view = new FileDialogButtonView( locale );
 *
 *		view.set( {
 *			acceptedType: 'image/*',
 *			allowMultipleFiles: true
 *		} );
 *
 *		view.buttonView.set( {
 *			label: t( 'Insert image' ),
 *			icon: imageIcon,
 *			tooltip: true
 *		} );
 *
 *		view.on( 'done', ( evt, files ) => {
 *			for ( const file of Array.from( files ) ) {
 *				console.log( 'Selected file', file );
 *			}
 *		} );
 *
 * @extends module:ui/view~View
 */

var FileDialogButtonView = /*#__PURE__*/function (_View) {
  _inherits(FileDialogButtonView, _View);

  var _super = _createSuper(FileDialogButtonView);

  /**
   * @inheritDoc
   */
  function FileDialogButtonView(locale) {
    var _this;

    _classCallCheck(this, FileDialogButtonView);

    _this = _super.call(this, locale);
    /**
     * The button view of the component.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */

    _this.buttonView = new ButtonView(locale);
    /**
     * A hidden `<input>` view used to execute file dialog.
     *
     * @protected
     * @member {module:upload/ui/filedialogbuttonview~FileInputView}
     */

    _this._fileInputView = new FileInputView(locale);
    /**
     * Accepted file types. Can be provided in form of file extensions, media type or one of:
     * * `audio/*`,
     * * `video/*`,
     * * `image/*`.
     *
     * @observable
     * @member {String} #acceptedType
     */

    _this._fileInputView.bind('acceptedType').to(_assertThisInitialized(_this));
    /**
     * Indicates if multiple files can be selected. Defaults to `true`.
     *
     * @observable
     * @member {Boolean} #allowMultipleFiles
     */


    _this._fileInputView.bind('allowMultipleFiles').to(_assertThisInitialized(_this));
    /**
     * Fired when file dialog is closed with file selected.
     *
     *		view.on( 'done', ( evt, files ) => {
     *			for ( const file of files ) {
     *				console.log( 'Selected file', file );
     *			}
     *		}
     *
     * @event done
     * @param {Array.<File>} files Array of selected files.
     */


    _this._fileInputView.delegate('done').to(_assertThisInitialized(_this));

    _this.setTemplate({
      tag: 'span',
      attributes: {
        class: 'ck-file-dialog-button'
      },
      children: [_this.buttonView, _this._fileInputView]
    });

    _this.buttonView.on('execute', function () {
      _this._fileInputView.open();
    });

    return _this;
  }
  /**
   * Focuses the {@link #buttonView}.
   */


  _createClass(FileDialogButtonView, [{
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }]);

  return FileDialogButtonView;
}(View);
/**
 * The hidden file input view class.
 *
 * @private
 * @extends module:ui/view~View
 */


export { FileDialogButtonView as default };

var FileInputView = /*#__PURE__*/function (_View2) {
  _inherits(FileInputView, _View2);

  var _super2 = _createSuper(FileInputView);

  /**
   * @inheritDoc
   */
  function FileInputView(locale) {
    var _this2;

    _classCallCheck(this, FileInputView);

    _this2 = _super2.call(this, locale);
    /**
     * Accepted file types. Can be provided in form of file extensions, media type or one of:
     * * `audio/*`,
     * * `video/*`,
     * * `image/*`.
     *
     * @observable
     * @member {String} #acceptedType
     */

    _this2.set('acceptedType');
    /**
     * Indicates if multiple files can be selected. Defaults to `false`.
     *
     * @observable
     * @member {Boolean} #allowMultipleFiles
     */


    _this2.set('allowMultipleFiles', false);

    var bind = _this2.bindTemplate;

    _this2.setTemplate({
      tag: 'input',
      attributes: {
        class: ['ck-hidden'],
        type: 'file',
        tabindex: '-1',
        accept: bind.to('acceptedType'),
        multiple: bind.to('allowMultipleFiles')
      },
      on: {
        // Removing from code coverage since we cannot programmatically set input element files.
        change: bind.to(
        /* istanbul ignore next */
        function () {
          if (_this2.element && _this2.element.files && _this2.element.files.length) {
            _this2.fire('done', _this2.element.files);
          }

          _this2.element.value = '';
        })
      }
    });

    return _this2;
  }
  /**
   * Opens file dialog.
   */


  _createClass(FileInputView, [{
    key: "open",
    value: function open() {
      this.element.click();
    }
  }]);

  return FileInputView;
}(View);